module.exports = __webpack_public_path__ + "img/musical-notes.7d6d71df.png";